import React, {useRef, useContext} from 'react';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

const AnimatedDates = () => {
	const { data: {content} } = useContext(Context);

	const animatedDatesContainer = useRef(null);

	useGSAP(() => {
		let mm = gsap.matchMedia();
		mm.add({
			isMobile: "(max-width: 1023px)",
			isDesktop: "(min-width: 1024px)",
		}, (context) => {
			const { isMobile, isDesktop } = context.conditions;

			gsap.set('.chapter-1__animated-date__scroll-up-text', {y: '100vh'});
			gsap.set('.chapter-1__animated-date__highlighted-text', {xPercent: -50});
			gsap.set('.chapter-1__animated-date__to-left-up', {xPercent: -50});

			if (isMobile) {
				gsap.set('.chapter-1__animated-date__slide-from-right', {xPercent: 50});
				gsap.set('.chapter-1__animated-date__slide-from-left', {xPercent: -50});
			}
		
			const numbers = gsap.utils.toArray('.chapter-1__animated-date__countdown');
			const split = new SplitText('.chapter-1__animated-date__highlighted-text', { type: 'chars, words', wordsClass: 'word' });

			const tl = gsap.timeline()
				.to(animatedDatesContainer.current, {
					backgroundColor: '#3d3327',
				})
				.from('.chapter-1__animated-date__slide-from-left', {
					x: '-100vw',
				}, '<')
				.from('.chapter-1__animated-date__slide-from-right', {
					x: '100vw',
				}, "<")
				.to('.chapter-1__animated-date__slide-from-left', {
					y: '-100vh',
					delay: 0.5,
				})
				.to('.chapter-1__animated-date__slide-from-right', {
					y: '-100vh',
				}, '<')
				.to(animatedDatesContainer.current, {
					backgroundColor: '#ece9e1',
				}, '<')
				.to('.chapter-1__animated-date__scroll-up-text', {
					y: '-100vh',
					duration: 3
				}, '-=0.4')
				.from((split.chars), {
					opacity: 0,
					rotate: (i) => {
						return -i * 0.1;
					},
					y: (i) => {
						return -i * 0.1;
					},
					skewY: -5,
					stagger: 0.05,
				}, '-=2.2')
				.from('.chapter-1__animated-date__to-left-up', {
					scale: 0,
				},'-=0.2')
				.to('.chapter-1__animated-date__highlighted-text', {
					y: '-100vh',
				})
				.to('.chapter-1__animated-date__to-left-up', {
					top: '30%',
					left: () => isDesktop ? '11%' : '50%',
					xPercent: () => isDesktop ? 0 : -50,
					color: '#B2A98D'
				}, '-=0.5')
				.to(animatedDatesContainer.current, {
					backgroundColor: '#3d3327',
				}, '<')
				.from('.chapter-1__animated-date__countdown', {
					opacity: 0,
					right: () => isDesktop ? '11%' : '50%',
					xPercent: () => isDesktop ? 0 : -50,
				})
				.to(animatedDatesContainer.current, {
					backgroundColor: '#CCC6CC',
				})
				.to(numbers, {
					innerText: 1887,
					snap: {
						innerText: 1,
					}
				}, '<')
				.to('.chapter-1__animated-date__to-left-up', {
					color: '#564C72'
				}, '<')
				.to('.chapter-1__animated-date__countdown', {
					color: '#564C72'
				}, '<')
			
			ScrollTrigger.create({
				trigger: animatedDatesContainer.current,
				start: 'top top',
				pin: true,
				end: () => 'bottom+=400%',
				scrub: 2,
				animation: tl,
			});
		});

	}, {scope: animatedDatesContainer.current, dependencies: [content.chapters]});

	return (
		<div className='chapter-1__animated-date' ref={animatedDatesContainer}>
			<div className='main-grid'>
				<div className='main-grid__margin'></div>
				<div className='main-grid__body'>
					<p className='chapter-1__animated-date__slide-from-left'>{content.chapters.first.animated_dates.date_1}</p>
					<p className='chapter-1__animated-date__slide-from-right'>{content.chapters.first.animated_dates.year_1}</p>
					<div className='chapter-1__animated-date__scroll-up-text'>
						<p className='chapter-1__animated-date__scroll-up-text__1'>
							{content.chapters.first.animated_dates.paragraph_1}
						</p>
						<p className='chapter-1__animated-date__scroll-up-text__2'>
							{content.chapters.first.animated_dates.paragraph_2}
						</p>
					</div>
					<p className='chapter-1__animated-date__highlighted-text teaser-sentence'>{content.chapters.first.animated_dates.highlighted_text}</p>
					<p className='chapter-1__animated-date__to-left-up'>{content.chapters.first.animated_dates.date_1}</p>
					<p className='chapter-1__animated-date__countdown'>{content.chapters.first.animated_dates.year_1}</p>
				</div>
				<div className='main-grid__margin'></div>
			</div>
		</div>

	)
};

export default AnimatedDates;